import { projectsData } from "../constants";

export const findById = ({ object, id }) => {
  console.log({ object, id });
  if (object === "projectsData") {
    const result = projectsData.find((project) => project.id === id) || null;
    return result;
  } else {
    return null;
  }
};
